import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { getFailureModeDisplayName } from '../../../utils/data/fmecaDataDefinition';
import { EditPanel, EditPanelButton, EditPanelButtons, EditPanelCell, EditPanelHeader, EditPanelRow } from '../../elements';
import { getOpenApiRouteItemUrlValidatingElements } from '../../validatingComponents/getOpenApiRouteItemUrlValidatingElements';
import { ValidatingEditPanelSaveButton } from '../../validatingElements';

const validatingElements = getOpenApiRouteItemUrlValidatingElements('/api/surveys/{surveyId}/failureModes/copy', 'post');

export function SurveyEditCopyFailureMode(props: {
    unitFailureModes: {
        id: string;
        defaultFailureMode: {
            name?: string | undefined;
        };
        customName?: string | undefined;
        metaData: string;
    }[];
    surveyId: string;
    onCancel: () => void;
    onSaved: () => Promise<void>;
    manifestationId: string;
}) {
    const translate = useTranslate();

    return (
        <EditPanel>
            <validatingElements.CreateUrlForm
                onSubmitted={props.onSaved}
                routeParams={{ surveyId: props.surveyId }}
                defaultItem={{ manifestationId: props.manifestationId }}
            >
                <EditPanelRow>
                    <EditPanelHeader text={translate('failureMode.functionAndFailureMode')} />
                </EditPanelRow>

                <EditPanelRow>
                    <EditPanelCell rowCount={12}>
                        <validatingElements.FilterDropdown
                            name="failureModeId"
                            selectOptions={props.unitFailureModes.map((i) => ({ text: getFailureModeDisplayName(i), value: i.id }))}
                        />
                    </EditPanelCell>
                </EditPanelRow>
                <EditPanelButtons>
                    <EditPanelButton onClick={() => props.onCancel()} text={translate('common.cancel')} small={true} />
                    <ValidatingEditPanelSaveButton small={true} />
                </EditPanelButtons>
            </validatingElements.CreateUrlForm>
        </EditPanel>
    );
}
